import React from "react";
import "./NewsList.scss";
import {MDBBox} from "mdbreact";
import {Link} from "react-router-dom";
import {Fade} from 'react-reveal'
import ReactTimeAgo from 'react-time-ago'
import {assetUrl} from "../../serviceApi";

const Coin = assetUrl+"images/coin.png";
const Clock = assetUrl+"images/ic_outline-access-time.svg";


class NewsList extends React.Component {
	render() {
		return (
			<MDBBox className="news-list-component">
				{
					this.props.news_list.map((item, index) => {
						return (
							<Link to={"/news/" + item.node.id} key={index}>
								<Fade bottom>
									<div className="d-flex align-items-center news-item">

											{/*<Hero id='hero-1' show={true}>*/}
												<img
													src={item.node.thumbnail !== "No Thumbnail" ? item.node.thumbnail : Coin}
													alt="Coin" className="img-fluid news-img"/>
											{/*</Hero>*/}

										<div className="news-detail">
											<p className="news_heading">{item.node.shortDescription}</p>
											<div className="news_express d-flex align-items-center">
												<p className="news_names">{item.node.source}</p>
												<div className="horizontal-line"/>
												<div className=" news_align d-flex align-items-center">

													<img src={Clock} alt="Clock"/>

													<div className="hours_tweet">
														<ReactTimeAgo date={item.node.created} locale="en-US"/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Fade>
							</Link>
						);
					},)
				}
				{
					this.props.news_list.length === 0 &&
					<div className={"error-section"}>No Datas Found</div>
				}
			</MDBBox>
		);
	}
}

export default NewsList;
